module.exports = __webpack_public_path__ + "static/media/billingIcon.f29d29ce.svg";